import React, { Component } from 'react';
import { StyleSheet, View, BackHandler } from 'react-native';
import { createBottomTabNavigator } from 'react-navigation';
import { observer } from 'mobx-react';
import { observe } from 'mobx';

import Header from './common/Header';

import HeroScreen from './HeroScreen';
import InventoryScreen from './Inventory/InventoryScreen';
import LocationScreen from './LocationScreen';

import appStore from '../stores/app';
import heroStore from '../stores/hero';
import combatStore from '../stores/combat';
import islandStore from '../stores/island';

import { BACKGROUND_COLOR } from './styleConstants';
import Footer from './common/Footer';
import { IS_WEB, EVENT_CLOSE_MODAL, EVENT_ALL_MODALS_CLOSED } from '../lib/appConstants';
import Chat from './Chat/index';

const tabNavigatorConfig = {
  initialRouteName: 'Hero',
  tabBarComponent: () => null,
  lazy: false,
  animationEnabled: false,
  swipeEnabled: false,
};

const Stack = createBottomTabNavigator(
  {
    Hero: { screen: HeroScreen },
    Inventory: { screen: InventoryScreen },
    Location: { screen: LocationScreen },
  },
  tabNavigatorConfig,
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: BACKGROUND_COLOR,
  },
});

type Props = {
  navigation: any;
};

@observer
export default class Inner extends Component<Props> {
  didFocusSubscription: any;

  willBlurSubscription: any;

  disposer: any;

  constructor(props: Props) {
    super(props);

    this.didFocusSubscription = props.navigation.addListener('didFocus', () =>
      BackHandler.addEventListener('hardwareBackPress', this.onBackPress as any),
    );
  }

  componentDidMount() {
    const { navigation } = this.props;
    this.willBlurSubscription = navigation.addListener('willBlur', () =>
      (BackHandler as any).removeEventListener('hardwareBackPress', this.onBackPress as any),
    );

    this.disposer = observe(heroStore.hero, 'combat', (change: any) => {
      function navigateToFromCombat() {
        if (change.newValue) {
          appStore.navigate('Combat', 'outer');
        } else {
          islandStore.fetch();
          combatStore.clear();
          appStore.navigate('Inner', 'outer', 'pop');
        }
        (appStore.toggleMenu as any)(false);
        appStore.toggleLoading(false);
        (global as any).emitter.removeAllListeners(EVENT_ALL_MODALS_CLOSED);
      }

      if (change.oldValue !== change.newValue) {
        if (!appStore.modalOpened) {
          navigateToFromCombat();
        } else {
          (global as any).emitter.addListener(EVENT_ALL_MODALS_CLOSED, navigateToFromCombat);
          (global as any).emitter.emit(EVENT_CLOSE_MODAL);
        }
      }
    });
  }

  componentWillUnmount() {
    if (this.didFocusSubscription) this.didFocusSubscription.remove();
    if (this.willBlurSubscription) this.willBlurSubscription.remove();

    this.disposer();
  }

  onBackPress = () => {
    appStore.updateCurrentNav();
  };

  render() {
    return (
      <View style={styles.container}>
        <Header />
        <Stack
          ref={(ref: any) => {
            appStore.setNavigationRef(ref, 'inner');
          }}
        />
        {IS_WEB ? <Footer {...({ divide: undefined } as any)} /> : null}
        <Chat id="inner" onHide={() => appStore.toggleChat(false)} visible={appStore.chat} />
      </View>
    );
  }
}
